<div class="request-part-container" [ngClass]="[_homePage ? ' mainhomePage' : 'mainnotHomePage']">
  <div class="">
    <form [formGroup]="createRequestFormGroup" class="section-form sp-container --fluid">
      <sp-steps *ngIf="currentStep > 0 && !validVINEnteredForCatalog" [list]="steps" direction="horizontal"
        [showDescription]="true"></sp-steps>
      <div class="sp-row">
        <div [ngClass]="[
            _homePage ? 'sp-col sp-col--5 sp-col-sm--12 widget-wrap homePage' : 'sp-col sp-col--8 sp-col-sm--12 widget-wrap notHomePage'
          ]">
          <div id="step-1" *ngIf="currentStep === 0 && _homePage" class="step-container">
            <div class="step-header">
              <h2>نوع الطلب</h2>
            </div>
            <div class="step-body">
              <div class="step-body-item">
                <sp-controls type="radio" class="radio-as-button" [data]="requestTypes" formControlName="partType"
                  (changeValue)="togglePartType($event)">
                </sp-controls>
              </div>
              <div class="popover-box hint_1">
                <p class="title">لماذا رقم الهيكل ؟</p>
                <div class="popover-box-details">
                  <div class="popover-widget">
                    <img src="/public/resources/images/car-front.png" />
                    <h3>لماذا رقم الهيكل؟</h3>
                    <p>رقم الهيكل يمكّننا من مطابقة القطع المطلوبة لمواصفات سيارتك</p>
                    <p>بإمكانك العثور على رقم الهيكل من خلال صورة استمارة السيارة أو خلف لوحة القيادة من الجهة الخارجية
                    </p>
                  </div>
                </div>
              </div>
              <div class="popover-box hint_2">
                <p class="title" (click)="openCustomPopup()">لماذا رقم الهيكل ؟</p>
                <div class="popover-box-details" (click)="closeCustomPopup()"
                  [ngClass]="[togglePopup ? 'close-menu' : 'open-menu']">
                  <div class="popover-widget">
                    <img src="/public/resources/images/car-front.png" />
                    <h3>لماذا رقم الهيكل؟</h3>
                    <p>رقم الهيكل يمكّننا من مطابقة القطع المطلوبة لمواصفات سيارتك</p>
                    <p>بإمكانك العثور على رقم الهيكل من خلال صورة استمارة السيارة أو خلف لوحة القيادة من الجهة الخارجية
                    </p>
                  </div>
                </div>
              </div>
              <div class="step-body-item vin-field new-vin-filed">
                <sp-input class="input-veh-number" [size]="'large'" (changeAction)="checkVinValidation()"
                  name="vinNumber" formControlName="vinNumber" type="text" [label]="'رقم الهيكل (مطلوب)'"></sp-input>
              </div>
            </div>
            <div class="step-footer">
              <div class="two-buttons custom-font">
                <sp-button
                  [label]="validVINEnteredForCatalog || vinLoading ? vinLabel : ('request_new.step_car' | translate)"
                  [style]="
                    createRequestFormGroup.get('partType').value && createRequestFormGroup.get('vinNumber').valid && !vinLoading
                      ? 'primary'
                      : 'disabled-style'
                  " [disabled]="
                    createRequestFormGroup.get('vinNumber').invalid || !createRequestFormGroup.get('partType').value || vinLoading
                  " [size]="'large'" class="full-width" [status]="loadingCatalog ? 'loading' : ''"
                  (clickAction)="validVINEnteredForCatalog ? redirectToCatalog() : setStep(false, 1)">
                </sp-button>
              </div>
            </div>
          </div>
          <div id="step-2" class="step-container" *ngIf="currentStep === 1">
            <div class="content-widget">
              <div class="step-header">
                <h2>مواصفات السيارة</h2>
              </div>
              <div class="step-body" *ngIf="!_homePage">
                <div class="step-body-item">
                  <p class="heading-5" *ngIf="userCarsList && userCarsList.length">اختر من سياراتك السابقة أو ادخل سيارة
                    جديدة</p>
                  <p class="heading-5" *ngIf="userCarsList && !userCarsList.length">ادخل سيارة جديدة</p>
                  <div class="choose-way">
                    <sp-button [size]="'default'"
                      [style]="userAction === 'addnewcar' ? 'secondary active' : 'secondary'"
                      (clickAction)="ToggleCars('addnewcar')" [label]="'اضف سيارة جديدة'" [type]="'button'"></sp-button>
                    <sp-button [size]="'default'" *ngIf="userCarsList && userCarsList.length"
                      [style]="userAction === 'chosemycars' ? 'secondary active' : 'secondary'"
                      (clickAction)="ToggleCars('chosemycars')" [type]="'button'" [label]="'اختر من سياراتك السابقة'">
                    </sp-button>
                  </div>
                </div>
              </div>
              <div class="step-body" *ngIf="userAction === 'chosemycars'">
                <div class="step-body-item" *ngIf="!_homePage">
                  <sp-controls type="radio" class="radio-as-button" [data]="requestTypes" formControlName="partType"
                    (changeValue)="togglePartType($event)">
                  </sp-controls>
                </div>
                <div class="step-body-item">
                  <sp-select *ngIf="userCarsList && userCarsList.length" bindValue="_id" [searchBox]="true"
                    [searchable]="true" [searchable]="true" bindLabel="nameArabic" [closeOnSelect]="true"
                    [(ngModel)]="myCarId" typeToSearchText="مثال كامري ٢٠١٠" loadingText="جاري البحث.."
                    notFoundText="لم يتم العثور على نتيجة مطابقة" [ngModelOptions]="{ standalone: true }"
                    [items]="userCarsItems" [placeholder]="'request_new.myCarId' | translate"
                    (onSelectChange)="selectingCarFromList($event)">
                  </sp-select>
                  <p *ngIf="userCarsList && !userCarsList.length">لا يوجد لديك سيارات سابقة, يجب اضافة سيارة اولاً</p>
                </div>
                <div class="step-body-item vin-field new-vin-filed">
                  <sp-input class="input-veh-number" [size]="'large'" (changeAction)="checkVinValidation()"
                    name="vinNumber" formControlName="vinNumber" type="text" [label]="'رقم الهيكل (مطلوب)'"></sp-input>
                </div>
              </div>
              <div class="step-body" *ngIf="userAction === 'addnewcar' || _homePage">
                <div class="step-body-item" *ngIf="!_homePage">
                  <sp-controls type="radio" class="radio-as-button" [data]="requestTypes" formControlName="partType"
                    (changeValue)="togglePartType($event)">
                  </sp-controls>
                </div>
                <div class="step-body-item vin-field new-vin-filed" *ngIf="!_homePage">
                  <sp-input class="input-veh-number" [size]="'large'" (changeAction)="checkVinValidation()"
                    name="vinNumber" formControlName="vinNumber" type="text" [label]="'رقم الهيكل (مطلوب)'"></sp-input>
                </div>
                <div class="step-body-item">
                  <!-- 6T1BE42K4BX678289 -->
                  <sp-select (onBlur)="resetFocus('openManifactureDp')" [focusAndOpen]="openManifactureDp"
                    [searchable]="true" bindValue="_id" bindLabel="nameArabic" formControlName="manufactureId"
                    [placeholder]="'request_new.manufactureId' | translate" [items]="manifictureItems"
                    (ngModelChange)="manufChanged(createRequestFormGroup.get('manufactureId').value)"
                    (onSelectChange)="resetModel()" [closeOnSelect]="true"
                    typeToSearchText="اكتب اسم الشركة المصنعة، مثال تويوتا" loadingText="جاري البحث.."
                    notFoundText="لم يتم العثور على نتيجة مطابقة">
                  </sp-select>
                </div>
                <div class="step-body-item">
                  <a (click)="handleClickOnDisabledDp('carSelectDb')">
                    <sp-select (onBlur)="resetFocus('openSelectCarDp')" [focusAndOpen]="openSelectCarDp"
                      [searchable]="true" [bindValue]="modelIdBindValue"
                      [disabled]="!createRequestFormGroup.get('manufactureId').value" bindLabel="nameArabic"
                      formControlName="modelId" [placeholder]="'request_new.modelId' | translate" [items]="modelItems"
                      (ngModelChange)="selectedModel($event)" [closeOnSelect]="true"
                      typeToSearchText="اكتب اسم السيارة ،مثال كامري" loadingText="جاري جلب المعلومات المدخلة.."
                      notFoundText="لم يتم العثور على نتيجة مطابقة"></sp-select>
                  </a>
                </div>
                <div class="step-body-item">
                  <a (click)="handleClickOnDisabledDp('yearSelectDb')">
                    <sp-select (onBlur)="resetFocus('openSelectYearDp')" [focusAndOpen]="openSelectYearDp"
                      formControlName="modelYear" [searchable]="true" [closeOnSelect]="true"
                      [disabled]="!createRequestFormGroup.get('modelId').value"
                      [placeholder]="'request_new.modelYear' | translate" [items]="yearItem" [bindLabel]="'label'"
                      [bindValue]="'id'" typeToSearchText="اكتب سنة الصنع، مثال ٢٠١٠"
                      loadingText="جاري جلب المعلومات المدخلة.." notFoundText="لم يتم العثور على نتيجة مطابقة">
                    </sp-select>
                  </a>
                </div>
                <ng-container *ngIf="matchingCarsCount > 1">
                  <div class="step-body-item" *ngIf="parameters?.engine?.length">
                    <sp-select [items]="parameters.engine" formControlName="engine" placeholder="مواصفات المحرك">
                    </sp-select>
                  </div>
                  <div class="step-body-item" *ngIf="parameters?.engine_capacity?.length">
                    <sp-select [items]="parameters.engine_capacity" formControlName="engine_capacity"
                      placeholder="سعة المحرك"> </sp-select>
                  </div>
                  <div class="step-body-item" *ngIf="parameters?.sales_region?.length">
                    <sp-select [items]="parameters.sales_region" formControlName="sales_region" placeholder="المنطقة">
                    </sp-select>
                  </div>
                  <div class="step-body-item" *ngIf="parameters?.engine_type?.length">
                    <sp-select [items]="parameters.engine_type" formControlName="engine_type" placeholder="نوع المحرك">
                    </sp-select>
                  </div>
                  <div class="step-body-item" *ngIf="parameters?.grade?.length">
                    <sp-select [items]="parameters.grade" formControlName="grade" placeholder="الفئة"> </sp-select>
                  </div>
                </ng-container>
                <div class="step-body-item" *ngIf="parameters?.trans_type?.length > 1">
                  <sp-select [items]="parameters.trans_type" formControlName="trans_type" placeholder="ناقل الحركة">
                  </sp-select>
                </div>
                <div class="step-body-item" *ngIf="parameters?.fuel_type?.length > 1">
                  <sp-select [items]="parameters.fuel_type" formControlName="fuel_type" placeholder="نوع الوقود">
                  </sp-select>
                </div>
              </div>

              <div class="step-footer">
                <div [ngClass]="[_homePage ? 'two-buttons custom-font' : 'two-buttons custom-font justify-content']">
                  <sp-button *ngIf="_homePage" [style]="'secondary'" [label]="'اختر نوع الطلب'" [size]="'large'"
                    class="full-width button-arrow-right" (clickAction)="setStep(false, 0)" icon="navigation-right-3">
                  </sp-button>
                  <sp-button *ngIf="_homePage"
                    [label]="loadingCatalogData ? 'جاري جلب معلومات السيارة...' : 'اختر قطع الغيار'"
                    [style]="isCarSelected() ? 'primary' : 'disabled-style'" [disabled]="!isCarSelected()"
                    [size]="'large'" class="full-width" (clickAction)="setStep(false, 2)">
                  </sp-button>
                  <sp-button *ngIf="userAction === 'addnewcar' && !_homePage"
                    [label]="validVINEnteredForCatalog || vinLoading ? vinLabel : ('request_new.step_parts' | translate)"
                    [style]="
                      createRequestFormGroup.get('partType').value && createRequestFormGroup.get('vinNumber').valid && !vinLoading
                        ? 'primary'
                        : 'disabled-style'
                    " [disabled]="
                      createRequestFormGroup.get('vinNumber').invalid || !createRequestFormGroup.get('partType').value || !isCarSelected()
                    " [size]="'large'" class="full-width" [status]="loadingCatalog ? 'loading' : ''"
                    (clickAction)="validVINEnteredForCatalog ? redirectToCatalog() : setStep(false, 2)">
                  </sp-button>
                </div>
                <div
                  [ngClass]="[validVINEnteredForCatalog ? 'two-buttons custom-font' : 'two-buttons custom-font justify-content']">
                  <sp-button *ngIf="userAction === 'chosemycars' && !_homePage"
                    [label]="validVINEnteredForCatalog || vinLoading ? vinLabel : ('request_new.step_parts' | translate)"
                    [style]="isCarSelected() ? 'primary' : 'disabled-style'"
                    [disabled]="!createRequestFormGroup.get('partType').value || vinLoading || !isCarSelected()"
                    [size]="'large'" class="full-width"
                    (clickAction)="validVINEnteredForCatalog ? redirectToCatalog() : setStep(false, 2)">
                  </sp-button>
                  <sp-button *ngIf="userAction === 'chosemycars' && !_homePage && validVINEnteredForCatalog"
                    [label]="'request_new.step_parts' | translate"
                    [style]="isCarSelected() ? 'primary' : 'disabled-style'"
                    [disabled]="!createRequestFormGroup.get('partType').value || vinLoading || !isCarSelected()"
                    [size]="'large'" class="full-width" (clickAction)="setStep(false, 2)">
                  </sp-button>
                </div>
              </div>
            </div>
          </div>
          <div id="step-3" *ngIf="currentStep === 2" class="step-container">
            <div class="step-header">
              <h2>ادخل القطع المطلوبة</h2>
              <sp-button *ngIf="createRequestFormGroup.get('parts').value?.length > 1" (clickAction)="removeAll()"
                [style]="'ghost negative'" icon="bin" [label]="'حذف الكل'">
              </sp-button>
            </div>
            <div class="step-body">
              <div class="step-body-item">
                <div formArrayName="parts" class="parts">
                  <div *ngFor="let part of getParts(); let i = index" [formGroupName]="i" class="part-item">
                    <div class="part-item-content">
                      <ul class="partname-photo">
                        <li class="part-name">
                          <sp-select [size]="'large'" [addTag]="false" [searchBox]="true" [searchable]="true"
                            [showBorder]="true" [bindValue]="'label'" itemsObjectName="hits" formControlName="name"
                            [closeOnSelect]="true" [valueAsObject]="false" [loading]="dataLoading"
                            [typeahead]="searchInput$" loadingText="جاري البحث.." [items]="partsListArray[i]"
                            [addTagText]="'اضافة اسم القطعة المدخل؟'" notFoundText="لم يتم العثور على نتيجة مطابقة"
                            typeToSearchText="اكتب اسم القطعة واختر من القائمة"
                            [placeholder]="'ابحث باسم القطعة، مثال: صدام أمامي'" (keyup)="changeValue($event, i)">
                          </sp-select>
                          <!-- <sp-input name="name" formControlName="name" type="text" [label]="'request_new.part_name' | translate"> </sp-input> -->
                          <div class="part-photo">
                            <input type="hidden" formControlName="photo" name="photo" />
                            <sp-input (change)="uploadImage($event, 'photo', i)"
                              [label]="'request_new.photo' | translate" [size]="'large'" [multiple]="'multiple'"
                              [photoUrl]="getPhotoUrl('photo', 'parts', i)" [type]="'file'"
                              [size]="'default upload-photo icon contain-icon'" [disabled]="uploadingPhoto"
                              icon="camera-1">
                            </sp-input>
                          </div>
                        </li>
                        <li class="part-quantity">
                          <sp-input name="quantity" [size]="'large'" [min]="1" formControlName="quantity" type="number"
                            [label]="'request_new.quantity' | translate"></sp-input>
                        </li>
                      </ul>
                      <div class="remove-part">
                        <sp-button *ngIf="i > 0" (clickAction)="removePart(i)" [style]="'ghost negative'" icon="bin"
                          [label]="''">
                        </sp-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="step-body-item">
                <sp-button class="display--block" [style]="'secondary'" icon="add-2" [size]="'large'"
                  [label]="'request_new.add_part' | translate" (clickAction)="addAnotherPart()">
                </sp-button>
              </div>
            </div>
            <div class="step-footer">
              <div class="two-buttons">
                <sp-button [style]="'secondary'" [label]="'متابعة التسوق بسيارة اخرى'" [size]="'large'"
                  class="full-width button-arrow-right" (clickAction)="setStep(false, 1)" icon="navigation-right-3">
                </sp-button>
                <sp-button [size]="'large'" class="full-width" [disabled]="!validQuotation"
                  [style]="validQuotation ? 'primary' : 'disabled-style'"
                  [label]="matchingQuotation() && validQuotation ? 'المتابعه للدفع' : 'أضف طلب تسعيرة للقطعة'"
                  (clickAction)="matchingQuotation() && validQuotation ? goToCheckout() : premiumQuotationHandler()">
                </sp-button>
                <sp-button *ngIf="!isAuthenticated" [disabled]="!createRequestFormGroup.valid"
                  [style]="createRequestFormGroup.valid ? '' : 'disabled-style'" [label]="'التالي'" [size]="'large'"
                  class="full-width" (clickAction)="setStep(false, 3)">
                </sp-button>
              </div>
            </div>
          </div>
          <div id="step-4" *ngIf="currentStep === 3" class="step-container
            login-step">
            <div class="step-header">
              <h2>ادخل رقم الجوال</h2>
            </div>
            <div class="step-body">
              <sp-mobile-login [anonymousUser]="true" [mobilePhoto]="false" [showBackStepButton]="true"
                (isAuthenticated)="setStep($event, 4)" (backStepHandler)="setStep(isAuthenticated, 2)">
              </sp-mobile-login>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <sp-modal [style]="requestSent.style" [type]="requestSent.type" [open]="requestSent.open" (toggle)="toggleModal()">
    <div class="modal-img center">
      <img src="/public/resources/images/b2b/request-done.svg" />
    </div>
    <div class="center">
      <h2 class="heading-2">تم ارسال طلبك بنجاح</h2>
    </div>
    <div class="center">
      <span>بإمكانك متابعة طلباتك من خلاص صفحة </span>
      <a routerLink="/requests/list">
        <sp-button [size]="'small'" [style]="'ghost'" [label]="'طلباتي'"></sp-button>
      </a>
    </div>
    <div class="reques-done center">
      <a routerLink="/requests/list">
        <sp-button [size]="'large'" [style]="'primary'" [label]="'تم'"></sp-button>
      </a>
    </div>
  </sp-modal>
</div>